import { renderedRadarDataAtom } from '@/atoms/radar';
import { useAtomValue } from 'jotai';

export const useHasEmptyRadar = () => {
  const renderedRadarData = useAtomValue(renderedRadarDataAtom);
  return renderedRadarData.every(metric => metric.value === metric.minValue);
};
